/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';
import { get } from 'lodash';
import moment from 'moment';

import UserAvatar from '../../Assets/Images/placeholder.png';
import SunburstFrame from '../../Assets/Images/sunburst_frame.png';

import './styles.scss';

const SoothePassMembershipCard = ({ client }) => {
  const state = get(client, 'soothe_pass.state', '');
  const soothePass = get(client, 'soothe_pass', {});
  const soothe_pass_extra_details = get(client, 'soothe_pass_extra_details', {});
  const points = get(client, 'points', 0);
  const {
    subscription_tier_name,
  } = soothePass;
  const {
    subscription_tier_price,
    subscription_next_charge_date,
  } = soothe_pass_extra_details;

  return (
    <div className="soothe-pass-membership-card">
      <div className='sm-display-flex align-items-center justify-content-around'>
        <div className=''>
          <div className="avatar-container">
            <img src={SunburstFrame} alt="sunburst frame" className="sunburst-frame" />
            <img src={UserAvatar || get(client, 'avatar_url', UserAvatar)} alt="user avatar" className="user-avatar" />
          </div>
        </div>
        <div className=''>
          <div className='txt-left'>
            {state === 'paused' ?
              <div className='mb-16'>
                <span className='yellow-badge'>Paused</span>
              </div>
              : null}
            <div className="size-28-36 contentPrimary font-weight-bold mb-16">
              {points} points
            </div>
            <div className="">
              <div className="size-16-20 contentPrimary font-weight-bold mb-8">{subscription_tier_name}</div>
              <div className="size-14-20 contentSecondary mb-4">{subscription_tier_price}</div>
              {subscription_next_charge_date && (
                <div className="size-12-20 contentSecondary">
                  {subscription_next_charge_date}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoothePassMembershipCard; 